import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  data: Record<string, any>;
}

/**
 * StructuredData - Generic wrapper for JSON-LD structured data
 *
 * Usage:
 * <StructuredData
 *   data={{
 *     '@context': 'https://schema.org',
 *     '@type': 'Article',
 *     headline: 'How TradeMagic Works',
 *     author: { '@type': 'Organization', name: 'TradeMagic' }
 *   }}
 * />
 */
export const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data, null, 2)}
      </script>
    </Helmet>
  );
};
